import script from "./DebugBox.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugBox.vue?vue&type=script&setup=true&lang=js"

import "./DebugBox.vue?vue&type=style&index=0&id=7d91aa26&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cube-viewer/cube-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d91aa26"]])

export default __exports__